const $ = require('jquery');
const i18next = require('i18next');

const Ui = require('./Ui');
const constants = require('../data/constants');
const Countries = require('./countries');
const Utils = require('./MappingUtils');

class AddressSearch {
  constructor(map, geocoder, preloader, storage, addressRouting) {
    this.map = map;
    this.preloader = preloader;
    this.geocoder = geocoder;
    this.coordinateGeocoder = new IWGeocoderClient();
    this.storage = storage;
    this.modal = $('.modal-search-address');
    this.contextMenu = $('#search-address-context-menu');
    this.addressRouting = addressRouting;
    this.countrySelector = this.modal.find(".countries-list");
    this.countries = new Countries();
    this.regex = /[a-zA-Z]/;
  }

  init() {
    this.addListeners();
    this.populateCountriesList();
  }

  doSearch(address) {
    this.preloader.showCursorPreloader();

    this.geocoder.geocodeAddressString(address, this.countrySelector.val(), constants.DISAMBIGUISATION_TOTAL_ADDRESSES, {
      type: constants.GEOCODING_TYPE_SEARCH_ADDRESS,
    });
  }

  doCoordinateSearch(coordinates) {
    this.preloader.showCursorPreloader();
    let coordinateSplit = coordinates.split(',');
    let coordinateType = IWCoordinate.MERCATOR;
    if(coordinateSplit[0] < 180 && coordinateSplit[0] > -180 && coordinateSplit[1] < 90 && coordinateSplit[1] > -90) {
      coordinateType = IWCoordinate.WGS84;
    }
    let coordinate = new IWCoordinate(coordinateSplit[1],coordinateSplit[0], coordinateType);
    this.coordinateGeocoder.reverseGeocodeByHits(coordinate , constants.DISAMBIGUISATION_TOTAL_ADDRESSES);
  }

  parseGeocodingResults(results) {
    if (!results || results.length === 0) {
      Ui.showModalError(i18next.t('errors.address-not-found'));
    } else if (results.length === 1) {
      this.showSearchedAddressOnMap(results[0].address);
    } else {
      this.showSearchDisambiguationDialog(results);
    }

    this.preloader.hideCursorPreloader();
  }

  showSearchDisambiguationDialog(results) {
    const disambiguationListContainer = $('#address-search-results-disambiguation');
    disambiguationListContainer.find('a').remove();

    results.forEach((result) => {
      const address = result.address;
      const hitprobability = result.hitprobability;
      const distance = result.distance;

      const listItem = $('<a href="#" class="list-group-item list-group-item-action"></a>');

      if(result.hitprobability) {
        listItem.html(`${address.toFormattedString()} <em>(${i18next.t('general.relevance')}: ${hitprobability}%)</em>`);
      } else if(result.distance) {
        listItem.html(`${address.toFormattedString()} <em>(${i18next.t('general.distance')}: ${Math.round(distance*100)/100}m)</em>`);
      } else {
        listItem.html(`${address.toFormattedString()}`);
      }


      listItem.on('click', (element) => {
        this.showSearchedAddressOnMap(address);
        element.preventDefault();
      });

      listItem.appendTo(disambiguationListContainer);
    });

    $('#search-results-disambiguation-container').show();
  }

  showSearchedAddressOnMap(address) {
    this.map.getOverlayManager().getLayer(constants.SEARCH_MARKERS_LAYER_ID).removeAllOverlays();
    const icon = new window.IWIcon(
      'img/search-map-marker.svg',
      new window.IWPoint(11, 32), new window.IWSize(23, 32),
    );

    const marker = new window.IWMarker(this.map, address.getCoordinate());
    marker.setDefaultIcon(icon);

    marker.onContextMenu = (event) => {
      event.preventDefault();

      this.contextMenu.find('#addressDetailsAddressSearch').html(
        Utils.getFormattedAddressName(address),
      );

      const addAsStartButton = $('#routing-add-start-from-search');
      const addAsDestinationButton = $('#routing-add-destination-from-search');

      addAsStartButton
        .off("click")
        .on('click', () => {
          this.addressRouting.setStartAddress(address, null,false);
        });

      addAsDestinationButton
        .off("click")
        .on('click', () => {
          this.addressRouting.setEndAddress(address,null, false)
        });

      const { x, y } = this.addressRouting.getClickInfo(event).position;
      this.contextMenu.css({ left: x, top: y }).show();
    };

    this.map.getOverlayManager().getLayer(constants.SEARCH_MARKERS_LAYER_ID).addOverlay(marker);

    this.map.setCenter(address.getCoordinate(), 15);

    this.modal.modal('hide');
  }

  populateCountriesList() {
    Object.keys(this.countries.iwCountries).forEach(function (code) {
      this.countrySelector.append($("<option>").val(code).text(this.countries.iwCountries[code]));
    }.bind(this));

    this.storage.getOption("countrySelectorSearchAddress")
      .then((result) => {
        let defaultCountry = result;
        if(!defaultCountry) defaultCountry = "deu";
        this.countrySelector.val(defaultCountry);
      });
  }

  addListeners() {
    $('#searchAddressAddress').on('input', (event) => {
      const currentValue = $(event.target).val();
      const submitButton = $('#searchAddressSubmit');

      if (currentValue.length >= 2 && currentValue.length <= 50) {
        submitButton.prop('disabled', false);
      } else {
        submitButton.prop('disabled', true);
      }
    });

    $('#searchAddressForm').on('submit', (event) => {
      const address = $('#searchAddressAddress').val();

      if (address.length >= 2 && address.length <= 50) {

        if(this.regex.test(address)) {
          this.doSearch(address);
        } else {
          this.doCoordinateSearch(address);
        }
      } else {
        Ui.showModalError(i18next.t('errors.please-add-address'));
      }

      event.preventDefault();
    });

    $('#searchAddressSubmit').on('click', () => {
      $('#searchAddressForm').submit();
    });

    this.modal.on('show.bs.modal', () => {
      $('#searchAddressAddress').val('');
      $('#search-results-disambiguation-container').hide();
    });

    this.countrySelector.on('change', () => {
      this.storage.putOption("countrySelectorSearchAddress", this.countrySelector.val());
    });

    window.IWEventManager.addCustomListener(this.geocoder, 'ongeocode', (event) => {
      this.parseGeocodingResults(event.results);
    });

    window.IWEventManager.addCustomListener(this.coordinateGeocoder, 'onreversegeocode', (event) => {
      this.parseGeocodingResults(event.results);
    });
  }
}

module.exports = AddressSearch;
